import { createContext } from 'react';

import type { HeadTags } from './headTags';

/**
 * Receives a page's head tags while it is being prerendered. Absent in the
 * browser, where Seo writes to document.head instead.
 */
export const SeoCollectorContext = createContext<((tags: HeadTags) => void) | null>(null);
